import styled from "@emotion/styled";

import { Loading } from "scmp-app/components/common/loading";

export const StyledLoading = styled(Loading)`
  margin-block: 40px;
`;
